import { render, staticRenderFns } from "./InvoiceExport.vue?vue&type=template&id=1a3980b2"
import script from "./InvoiceExport.vue?vue&type=script&lang=js"
export * from "./InvoiceExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports